import { BaseEntity, DefaultResponseWithData } from "./system";
import { IVehicle } from "./Vehicle";

export interface IExportOfferResponse extends DefaultResponseWithData<IExportOffer[]> { }

export interface IExportOffer extends BaseEntity {
  price: number;
  source: ExportSource;
  type: ExportType;
  userId: string | null;
  isAccepted: boolean;
  vehicleId: string;
  vehicle: IVehicle;
}

export enum ExportSource {
  Other,
  EnginesWorldwide
}

export enum ExportType {
  Vehicle,
  Engine,
  FrontEnd,
  Declined,
}